<template>
  <div class="author">
    <div class="author_nav">
      <div class="author_left">
        <div style="width: 95%;margin: 0 auto;background-color: #FFFFFF;">
<!--          <div class="shuxian">
            <div class="Journalism_xian1"></div>
            <div class="Journalism_xian2"></div>
          </div> -->
          
          <div class="video_title">
            
            
            <div v-for="(item,index) in title" :key="index" class="video_txt" v-if="index<4" @click="dian(item.zt,item.id)">

              <div class="video_name" :class="item.zt?'addtxt':''">

                 <div style="width: auto;display: inline-block;padding-bottom: 11px;" :class="item.zt?'xian':''">{{item.txt}}</div>
                 
              </div>

              <div class="video_xian" v-if="index<2"></div>
              
            </div>

            <div class="video_right">
              <div class="zi" @click="jumpduo">MORE></div>
            </div>

          </div>


          <div class="author_nav2r" style="margin-right: 4%;">

            <div class="author_list2" v-for="(item,index) in list" :key="index" v-if="index<4" @click="jump(item.contentId?item.contentId:item.id,item.year,item.issue,item)">
              <div class="author_dian" :class="item.zt?'add2':''" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)"></div>
              <div class="author_wen" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)">
                <div class="wen1" :class="item.zt?'add1':''">{{item.title}}</div>
                <div class="wen2">{{item.author}}</div>
              </div>
              
              <div class="zhai">
                <div class="wen3" v-if="num!=3">{{item.addDate}}</div>
                <div class="wen3" v-if="num==3">{{item.yearVolumeIssue}}</div>
                <div style="width: 42%;float: left;">
                  <div class="zhai_right" @click.stop="down(item.contentId?item.contentId:item.id)">下载</div>
                  <div class="zhai_left">摘要</div>
                </div>
              </div>
            </div>

          </div>

          <div class="author_nav2r">
            <div class="author_list2" v-for="(item,index) in list" :key="index" v-if="index>3&&index<8" @click="jump(item.contentId?item.contentId:item.id,item.year,item.issue,item)">
              <div class="author_dian" :class="item.zt?'add2':''" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)"></div>
              <div class="author_wen" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)">
                <div class="wen1" :class="item.zt?'add1':''">{{item.title}}</div>
                <div class="wen2">{{item.author}}</div>
              </div>
              <div class="zhai">
                <div class="wen3" v-if="num!=3">{{item.addDate}}</div>
                <div class="wen3" v-if="num==3">{{item.yearVolumeIssue}}</div>
                <div style="width: 42%;float: left;">
                  <div class="zhai_right" @click.stop="down(item.contentId?item.contentId:item.id)">下载</div>
                  <div class="zhai_left">摘要</div>
                </div>
              </div>
            </div>
          </div>

          
        </div>
      </div>
      <div class="author_right">
        <div style="width: 90%;margin: 0 auto;">
          <div class="author_title">
            <div class="author_xian"></div>
            <div class="author_txt">新闻公告</div>
          </div>
          <div class="author_nav2r">
            <vue-seamless-scroll :data='list2' :class-option="optionLeft" step="1" style="height: 386px;" >
              <div class="author_list2" v-for="(item,index) in list2" :key="index">
                <router-link :to="{path:'expert_details',query: {num:8,contentId:item.contentId?item.contentId:item.id,channelId:item.channelId}} ">
                  <div class="author_dian" :class="item.zt?'add2':''" @mouseover="addtop2(1,index)" @mouseout="addtop2(2,index)"></div>
                    <div class="author_wen" @mouseover="addtop2(1,index)" @mouseout="addtop2(2,index)">
                    <div class="wen1" :class="item.zt?'add1':''">{{item.title}}</div>
                  </div>
                </router-link>
              </div>
            </vue-seamless-scroll>
           </div>
          </div>
        </div>
      <div class="author_bottom">
<!--        <ul>
          <li>
            <img src="/src/assets/gg01.jpg" alt="">
          </li>
          <li>
            <img src="/src/assets/gg02.jpg" alt="">
          </li>
          <li>
            <img src="/src/assets/gg03.jpg" alt="">
          </li>
          <li>
            <img src="/src/assets/gg04.jpg" alt="">
          </li>
        </ul> -->
        <div class="Essence_bottoml" @click="tiaozhuan">
          <img src="/src/assets/tu71.png" alt="">
        </div>
<!--        <div class="Essence_bottomr2">
          <img src="/src/assets/gg01.jpg" alt="">
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>

 export default {
  data () {
    return {
      num: 1,//1.在线发表 2.精华集萃 3.热门文献 4.研究快讯
      title:[
        {
          id: 1,
          txt: '在线发表'
        },
        {
          id: 2,
          txt: '精华集萃'
        },
        {
          id: 3,
          txt: '热门文献'
        },
        {
          id: 4,
          txt: '研究快讯'
        },
      ],
      list: [],//在线发表
      list2: [],//期刊收录
      contentId:'',
      channelId:''
    }
  },methods:{
    tiaozhuan(){
      var item = {
        channelId: 2803,
        contentId: 164068,
        dataShowType: 1,
        dataSourceType: 1,
        issue: 0,
        journalId: 201607080003,
        year: 0
      }
      var data = JSON.stringify(item);
      this.$router.push({path:'/poster_details',query:{item:data}});
    },
    down(contentId){
      var that = this;
      that.$httphelper.GetContentFilePath({
        "journalId": that.$_JournalId,
        "contentId": contentId,
        "downType": 1
      }).then(res => {
        if(res.code==200){
          window.open(res.data);
          that.$loading.hideLoading();
        }else{
          that.$alert('没有附件', '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    jumpduo(){

      if(this.num==1){
       this.$router.push({path:'/download_details',query:{titlename:'在线发表'}});
      }else if(this.num==2){
       this.$router.push({path:'/download_details',query:{titlename:'精华集萃'}});
      }else if(this.num==3){

       this.$router.push({path:'/download_details',query:{titlename:'热门文献'}});
      }else if(this.num==4){
        // ',query: {num:8,contentId:item.contentId?item.contentId:item.id,channelId:item.channelId}}
       this.$router.push({path:'/download_details',query:{titlename:'研究快讯'}});
      }
      
    },
    //获取网站 首页模块信息 / 点击栏目得到的数据信息
    GetHomePageBlockInfo(channelId,jChannelID,dataSourceType){
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": that.$_JournalId,
        "pChannelId": 0,
        "channelId": channelId,
        "jChannelID": jChannelID,
        "dataSourceType": dataSourceType,
        "dataShowType": 1,
        "curr": 1,
        "limit": 10,
      }).then(res => {
        if(res.code==200){
          if(channelId==2823){
            that.list2 = res.data || '';
          }
            else{
            that.list = res.data || '';
          }
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    
    //热门文献
    GetJournalArticleList(){
      var that = this;
      that.$httphelper.GetJournalArticleList({
        "journalId": that.$_JournalId,
        "queryType": 3,
        "curr": 1,
        "limit": 8
      }).then(res => {
        if(res.code==200){
          that.list = res.data || '';
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //初始化页面
    index(){
      //在线发表
      this.GetHomePageBlockInfo(0,1388,3);
      //期刊收录

      this.GetHomePageBlockInfo(2823,0,1);

      for(var i=0;i<this.title.length;i++){
        if(i==0){
          this.title[i].zt = true;
          this.title.push('1');
          this.title.pop('1');
        }else{
          this.title[i].zt = false;
          this.title.push('1');
          this.title.pop('1');
        }
      }
    },
    //标题点击事件
    dian(zt,id){
      this.num = id;
      if(id==1){
        //在线发表
        this.GetHomePageBlockInfo(0,1388,3);

      }else if(id==2){
        //精华集萃
        this.GetHomePageBlockInfo(0,1382,3);
      }else if(id==3){
        //热门文献
        this.GetJournalArticleList();
      }else if(id==4){
        //研究快讯
        this.GetHomePageBlockInfo(2864,0,1);


      }

      if(!zt){
        for(var i=0;i<this.title.length;i++){
          if(id==this.title[i].id){
            this.title[i].zt = true;
            this.title.push('1');
            this.title.pop('1');
          }else{
            this.title[i].zt = false;
            this.title.push('1');
            this.title.pop('1');
          }
        }
      }
    },
    //读者鼠标悬停
    addtop(num,id){
      if(num==1){
        for(var i=0;i<this.list.length;i++){
          if(id==i){
            this.list[i].zt = true;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      }else{
        for(var i=0;i<this.list.length;i++){
          this.list[i].zt = false;
          this.list.push('1');
          this.list.pop('1');
        }
      }
    },
    addtop2(num,id){
      if(num==1){
        for(var i=0;i<this.list2.length;i++){
          if(id==i){
            this.list2[i].zt = true;
            this.list2.push('1');
            this.list2.pop('1');
          }
        }
      }else{
        for(var i=0;i<this.list2.length;i++){
          this.list2[i].zt = false;
          this.list2.push('1');
          this.list2.pop('1');
        }
      }
    },
    jump(contentId,year,issue,item){

      if(item.channelId==0){
        
        this.$router.push({path:'/browse_details',query:{year:item.year,issue:item.issue,issuecid:item.contentId}});
      }else{
        this.$router.push({path:'/expert_details',query:{num:8,contentId:item.contentId?item.contentId:item.id,channelId:item.channelId}});
        
      }

    },
  },
  computed: {
      optionLeft () {
        return {
          limitMoveNum: 8,
          direction: 1,
        }
      }
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
.author{
  width: 100%;
  min-width: 1366px;
  background-color: #F7F8FA;
  padding-top: 40px;
  .author_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    .author_left{
      width: 75%;
      height: 443px;
      float: left;
      padding-top: 14px;
      position: relative;
      background-color: #FFFFFF;
      padding-bottom: 25px;
      .shuxian{
        width: 10%;
        position: absolute;
        left: 20px;
        top: 16px;
        .Journalism_xian1{
          width: 4px;
          height: 21px;
          background: var(--xt);
          float: left;
          margin-right: 4px;
          margin-top: 7px;
        }
        .Journalism_xian2{
          width: 2px;
          height: 21px;
          background: var(--xt);
          float: left;
          margin-right: 12px;
          margin-top: 7px;
        }
      }
      .video_title{
        width: 100%;
        height: 38px;
        border-bottom: 3px solid #DBDBDB;
        position: relative;
        margin-bottom: 30px;
        padding-bottom: 11px;
        .video_name{
          width: 100%;
          font-size: 18px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #000000;
          line-height: 38px;
          position: relative;

          .video_xian2{
            width: 100%;
            height: 3px;
            background-color: var(--biao);
            position: absolute;
            left: 0;
            bottom: -13px;
          }
        }

        .video_xian{
          width: 4px;
          height: 21px;
          background: var(--xt);
          position: absolute;
          right: 0;
          top: 14px;
        }
        .video_txt{
          width: 16%;
          cursor: pointer;
          font-size: 18px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #000000;
          line-height: 38px;
          position: relative;
          text-align: center;
          float: left;
          .video_xian{
            width: 2px;
            height: 16px;
            background: #EEEEEE;
            position: absolute;
            right: 0;
            top: 14px;
          }
        }
        .video_txt:first-child{
          width: 12%;
          text-align: left;
        }
        .video_right{
          float: right;
          width: 90px;
          height: 12px;
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #878787;
          line-height: 23px;
          cursor: pointer;
          text-align: right;
          .zi{
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #878787;
            line-height: 23px;
            margin-right: 9px;
            margin-top: 8px;
          }
        }
      }
      .author_nav2r{
        width: 48%;
        float: left;
        overflow: hidden;
        .author_list2{
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 30px;
          .author_dian{
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 21px;
            float: left;
            margin-top: 6px;
          }
          .author_wen{
            width: 80%;
            float: left;
            .wen1{
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow:hidden;
            }
            .wen2{
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow:hidden;
            }
          }
          .zhai{
            width: 94%;
            padding-left: 31px;
            overflow: hidden;
            float: left;
            .wen3{
              width: 55%;
              float: left;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
            }
            .zhai_left,.zhai_right{
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }
            .zhai_right{
              margin-left: 30px;
            }
            .zhai_left:hover{
              text-decoration: underline;
              color: var(--biao);
            }
            .zhai_right:hover{
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
    }
    .author_right{
      width: 24%;
      float: left;
      margin-left: 1%;
      background-color: #FFFFFF;
      .author_title{
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        position: relative;
        padding-top: 30px;
        .author_xian{
          width: 80px;
          height: 3px;
          background-color: var(--biao);
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .author_txt{
          width: 50%;
          float: left;
          font-size: 20px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #000000;
          line-height: 23px;
          position: relative;
          padding-bottom: 11px;
        }
      }
      .author_nav2r{
        width: 100%;
        overflow: hidden;
        margin-top: 28px;
        // padding-bottom: 30px;
        .author_list2{
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 24px;
          .author_dian{
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 21px;
            float: left;
            margin-top: 6px;
          }
          .author_wen{
            width: 85%;
            float: left;
            .wen1{
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow:hidden;
            }
          }
        }
      }
    }
    .author_bottom{
      width: 100%;
      overflow: hidden;
      padding-top: 36px;
      padding-bottom: 68px;
      .Essence_bottoml{
        width: 100%;
        margin-right: 1%;
        float: left;
        img{
          width: 100%;
          height: 120px;
          background-size: cover;
          cursor: pointer;
          object-fit: cover;
        }
        img:hover{
          transform: scale(1.05);
        }
      }
      .Essence_bottomr2{
        width: 28%;
        height: 120px;
        float: left;
        img{
          width: 100%;
          height: 120px;
          background-size: cover;
          cursor: pointer;
        }
        img:hover{
          transform: scale(1.05);
        }
      }
      ul{
        width: 100%;
        list-style: none;
        overflow: hidden;
        padding-left: 0;
        li{
          width: 24%;
          margin-right: 1.33%;
          float: left;
          cursor: pointer;
          img{
            width: 100%;
            height: 120px;
          }
          img:hover{
            transform: scale(1.05);
          }
        }
        li:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
.add1{
  color: var(--xt)!important;
  text-decoration: underline;
}
.add2{
  background-color: var(--xt)!important;
}
.addtxt{
  font-weight: bold!important;
  font-size: 20px!important;
}
.xian{
  border-bottom: 3px solid var(--xt)!important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/home/author.vue